import { getExtension } from '../Extensions';
import { getExtension as getExtensionV2 } from '../ExtensionsV2';
import { DefaultExtension, DefaultExtensionV2 } from '../extensions/DefaultExtension';
export const runBehavior = async (behaviorType, version, {
  typeDef,
  hasAllGates,
  hasAllScopes,
  pageType,
  viewId
}) => {
  const defaultExtension = version === 'v1' ? DefaultExtension : DefaultExtensionV2;
  if (!defaultExtension[behaviorType]) {
    throw new Error(`Behavior ${behaviorType} not found`);
  }
  const defaultValue = defaultExtension[behaviorType]({
    typeDef,
    hasAllGates,
    hasAllScopes,
    pageType,
    viewId
  });
  const extension = await (version === 'v1' ? getExtension(typeDef.objectTypeId) : getExtensionV2(typeDef.objectTypeId));
  if (!extension) {
    return defaultValue;
  }
  const behavior = extension[behaviorType];
  if (!behavior) {
    return defaultValue;
  }
  return behavior({
    typeDef,
    hasAllGates,
    hasAllScopes,
    pageType,
    viewId
  });
};